import { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    TextField,
    Checkbox,
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Autocomplete
} from '@mui/material';
import ImagePicker from 'components/MDImagePicker';
import MDButton from "components/MDButton";
import SearchAutocomplete from 'components/SearchAutocomplete'

export default function CreateUserDialog({
    open,
    user,
    onChange,
    onCancel,
    onConfirm,
    onSelectedValue,
    suppliers,
    tennants,
    selectedSupplier,
    selectedTennant,
    permissoesOptions,
    onSupplierSearch,
    onTennantSearch,
    searchSupplierLoading,
    searchTennantLoading,
}) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Criar Usuário</DialogTitle>

            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        width: "100%",
                        mt: 4,
                        mb: 2
                    }}
                >
                    <TextField
                        fullWidth
                        label="Nome"
                        type="text"
                        variant="outlined"
                        value={user?.Name || ''}
                        onChange={(e) => onChange('Name', e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="E-mail"
                        type="email"
                        variant="outlined"
                        value={user?.Email || ''}
                        onChange={(e) => onChange('Email', e.target.value)}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        width: "100%",
                        mb: 2
                    }}
                >
                    <SearchAutocomplete
                        label="Empresa"
                        options={tennants}
                        loading={searchTennantLoading}
                        value={selectedTennant}
                        getOptionLabel={(tennant) =>
                            tennant
                                ? `${tennant.Id} - ${tennant.CompanyName}`
                                : ''
                        }
                        onSearch={onTennantSearch}
                        onChange={(tennant) => {
                            onSelectedValue(tennant, 'Tennant')
                            onChange(
                                'TennantId',
                                tennant ? tennant.Id : null
                            );
                        }}
                    />

                    <SearchAutocomplete
                        label="Fornecedor"
                        options={suppliers}
                        loading={searchSupplierLoading}
                        value={selectedSupplier}
                        getOptionLabel={(supplier) =>
                            supplier
                                ? `${supplier.Id} - ${supplier.CompanyName}`
                                : ''
                        }
                        onSearch={onSupplierSearch}
                        onChange={(supplier) => {
                            onSelectedValue(supplier, 'Supplier')
                            onChange(
                                'SupplierId',
                                supplier ? supplier.Id : null
                            );
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        width: "100%",
                        mb: 2
                    }}
                >
                    <FormControl fullWidth variant="outlined" sx={{ minWidth: 200 }}>
                        <InputLabel id="permission-select-label">
                            Permissão
                        </InputLabel>

                        <Select
                            labelId="permission-select-label"
                            id="permission-select"
                            value={user?.Role?.Id ?? ''}
                            label="Permissão"
                            onChange={(e) => { onChange('RoleId', e.target.value) }}
                            sx={{
                                height: "45px"
                            }}
                        >
                            {permissoesOptions.map((option) => (
                                <MenuItem
                                    key={option.Value}
                                    value={option.Value}
                                >
                                    {option.Label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControlLabel
                        label="Principal?"
                        labelPlacement='start'
                        sx={{ width: "30%", pb: 2 }}
                        control={
                            <Checkbox
                                checked={(user?.Main ?? false)}
                                onChange={(e) => onChange('Main', (e?.target?.checked || false))}
                            />
                        } />
                </Box>
            </DialogContent>

            <DialogActions>
                <MDButton variant="contained" color="success" size="medium" onClick={onConfirm}>
                    Salvar
                </MDButton>
                <MDButton variant="contained" color="info" size="medium" onClick={onCancel}>
                    Cancelar
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}